/**
 * This file contains the list of all icons used in the application.
 * It is auto-generated by `scripts/sync-icon-list.ts` based on
 * `icon="..."` references found across `src/`. Do not edit by hand.
 *
 * Runs automatically before `dev` and `build` (predev / prebuild).
 */

export const iconList = [
  'logos:google-icon',
  'logos:microsoft-icon',
  'lucide:activity',
  'lucide:archive',
  'lucide:arrow-down',
  'lucide:arrow-left',
  'lucide:arrow-right',
  'lucide:arrow-right-left',
  'lucide:arrow-up',
  'lucide:arrow-up-down',
  'lucide:arrow-up-right',
  'lucide:award',
  'lucide:badge-check',
  'lucide:bell-off',
  'lucide:book-open',
  'lucide:boxes',
  'lucide:brain',
  'lucide:building-2',
  'lucide:calendar',
  'lucide:calendar-days',
  'lucide:calendar-range',
  'lucide:calendar-x',
  'lucide:chart-column',
  'lucide:check',
  'lucide:check-check',
  'lucide:check-circle',
  'lucide:chevron-down',
  'lucide:chevron-left',
  'lucide:chevron-right',
  'lucide:chevron-up',
  'lucide:circle',
  'lucide:circle-alert',
  'lucide:circle-check',
  'lucide:circle-check-big',
  'lucide:circle-dashed',
  'lucide:circle-help',
  'lucide:circle-plus',
  'lucide:circle-x',
  'lucide:clock',
  'lucide:cloud-off',
  'lucide:cloud-upload',
  'lucide:compass',
  'lucide:copy',
  'lucide:download',
  'lucide:ellipsis',
  'lucide:ellipsis-vertical',
  'lucide:external-link',
  'lucide:eye',
  'lucide:eye-off',
  'lucide:fast-forward',
  'lucide:file',
  'lucide:file-audio',
  'lucide:file-text',
  'lucide:file-video',
  'lucide:filter',
  'lucide:flag',
  'lucide:flask-conical',
  'lucide:folder',
  'lucide:globe',
  'lucide:graduation-cap',
  'lucide:grip-vertical',
  'lucide:hand',
  'lucide:hash',
  'lucide:history',
  'lucide:hourglass',
  'lucide:house',
  'lucide:image',
  'lucide:image-off',
  'lucide:image-plus',
  'lucide:images',
  'lucide:inbox',
  'lucide:info',
  'lucide:languages',
  'lucide:layers',
  'lucide:layout-dashboard',
  'lucide:layout-grid',
  'lucide:link',
  'lucide:list',
  'lucide:list-checks',
  'lucide:list-filter',
  'lucide:list-ordered',
  'lucide:list-tree',
  'lucide:loader-circle',
  'lucide:lock',
  'lucide:log-out',
  'lucide:mail',
  'lucide:menu',
  'lucide:message-circle-question',
  'lucide:messages-square',
  'lucide:mic',
  'lucide:minus',
  'lucide:monitor',
  'lucide:moon',
  'lucide:move',
  'lucide:octagon-alert',
  'lucide:panel-left',
  'lucide:pause',
  'lucide:pencil',
  'lucide:pencil-line',
  'lucide:play',
  'lucide:plus',
  'lucide:refresh-cw',
  'lucide:rocket',
  'lucide:rotate-ccw',
  'lucide:rotate-cw',
  'lucide:save',
  'lucide:search',
  'lucide:search-x',
  'lucide:settings',
  'lucide:share-2',
  'lucide:shield-x',
  'lucide:sliders-horizontal',
  'lucide:smartphone',
  'lucide:smile',
  'lucide:sparkles',
  'lucide:square',
  'lucide:square-kanban',
  'lucide:sun',
  'lucide:sunrise',
  'lucide:sunset',
  'lucide:trash-2',
  'lucide:trending-up',
  'lucide:triangle-alert',
  'lucide:trophy',
  'lucide:type',
  'lucide:undo-2',
  'lucide:upload',
  'lucide:user-minus',
  'lucide:user-plus',
  'lucide:user-round',
  'lucide:user-x',
  'lucide:users',
  'lucide:wand-sparkles',
  'lucide:workflow',
  'lucide:x',
  'lucide:zap',
  'lucide:zoom-in',
  'lucide:zoom-out',
  'material-symbols:check-circle',
  'material-symbols:error',
  'material-symbols:task-alt',
  'material-symbols:warning',
  'mdi:eye-off',
  'mdi:slack',
] as const;

export type IconName = typeof iconList[number];

export function isValidIconName(name: string): name is IconName {
  return (iconList as readonly string[]).includes(name);
}
